//
//
//
//
//
//
//

import dateUtils from '@/modules/dateUtils'

export default {
  props: {
    date: { type: String, default: '' }
  },
  methods: {
    formatDate: dateUtils.format,
    isOverdue: dateUtils.isOverdue,
    dueSoon: dateUtils.dueSoon
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/DueDay.vue